// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1b9zv","type":"styles_type__3gwuh","choices":"styles_choices__J9E3r"};